
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth);
  
  return isAuthenticated.token !=="" ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
